"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.greeter = exports.utils = exports.coreService = exports.emailService = exports.tournamentServer = exports.emailTemplateService = exports.platform = exports.interfaces = exports.notificationsService = exports.customContentService = exports.contentService = exports.setGlobalSkipErrorValidation = exports.setOnUnauthorizedError = exports.requests = exports.ApolloProvider = void 0;
var client_1 = require("@apollo/client");
Object.defineProperty(exports, "ApolloProvider", { enumerable: true, get: function () { return client_1.ApolloProvider; } });
var rest_1 = require("./rest");
Object.defineProperty(exports, "requests", { enumerable: true, get: function () { return __importDefault(rest_1).default; } });
Object.defineProperty(exports, "setOnUnauthorizedError", { enumerable: true, get: function () { return rest_1.setOnUnauthorizedError; } });
Object.defineProperty(exports, "setGlobalSkipErrorValidation", { enumerable: true, get: function () { return rest_1.setGlobalSkipErrorValidation; } });
__exportStar(require("./interfaces"), exports);
exports.contentService = __importStar(require("./contentService"));
exports.customContentService = __importStar(require("./customContentService"));
exports.notificationsService = __importStar(require("./notificationsService"));
exports.interfaces = __importStar(require("./interfaces"));
exports.platform = __importStar(require("./platfrom"));
exports.emailTemplateService = __importStar(require("./emailTemplateService"));
exports.tournamentServer = __importStar(require("./tournaments"));
exports.emailService = __importStar(require("./emailService"));
exports.coreService = __importStar(require("./core"));
exports.utils = __importStar(require("./utils"));
var greeter = function () {
    return 'Hello from network-utils';
};
exports.greeter = greeter;
